Vue = require 'vue'
module.exports = new Vue



// WEBPACK FOOTER //
// ./src/libraries/events_bus.coffee